/* eslint-disable no-unused-vars */
import { useContext } from 'react';
// import MoxoModal from "./MoxoModal";
import {
  Box,
  Card,
  Grid,
  Tooltip,
  Typography,
  useMediaQuery,
} from '@mui/material';
import { ReactComponent as ForwardArrow } from 'assets/icons/forward_arrow.svg';
import { datacontext } from 'modules/AppLayout/AppLayout';
import {
  displayFlex,
  displayFlexColumn,
  fontsize10,
  fontsize14,
  fontsize8,
  poppins400,
  poppins500,
} from 'theme/common.style';
import { getbinderswithtags, getMoxoBinder } from 'api/rcpapiService';
import Loading from 'assets/images/loading.png';
import LabelHeader from 'component/LabelHeader/LabelHeader';
import { useEffect, useState } from 'react';
import { getApiCall } from 'api/apiService';
import { CommunicationAvataGroup } from 'component/ExpandedBuyerCard/ExpendedCardDocumentation';
import { LoaderContext } from 'component/Loader/LoaderContextProvider';
import {
  GET_PROPERTY_INDIVIDUAL,
  GET_PROPERTY_INDIVIDUAL_BUYER,
  GET_PROPERTY_INDIVIDUAL_VENDOR,
  RCP_API_URL,
} from 'constant/app.config';
import dayjs from 'dayjs';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { messageCardCont, messagingCont } from './MessagingContainer.style';
import Moxochat from 'component/Moxochat/Moxochat';
import { useTheme } from '@emotion/react';
import { PropertyContext } from 'component/PropertyContext/PropertyContext';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

export const lastseen = {
  width: 'fit-content',
  padding: '4px',
  background: 'rgba(217, 217, 217, 0.28)',
  borderRadius: '5px',
  height: 'fit-content',
};
export const lastseen6 = {
  width: '16px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',

  borderRadius: '5px',
  height: '16px',
};

export const Loadingfunc = () => {
  return (
    <Grid
      sx={{
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
        alignItems: 'center',
        width: '100%',
        paddingTop: '10%',
      }}
    >
      <img
        alt="Logo"
        src={Loading}
        className="loaderImage"
        style={{ height: '50px', width: '50px' }}
      />
    </Grid>
  );
};
function MessagingContainer(props) {
  const {
    onShowChat,
    binders,
    UserCard,
    userEmail,
    ContactUserCard,
    market,
    activityupdate,
    proid,
    InitiateSign,
    setOpenbinder,
  } = props;
  const [moxoData, setMoxoData] = useState([]);
  const [binderData, setBinderData] = useState([]);
  const [binderLoader, setBinderLoader] = useState(true);
  const params = useParams();
  const history = useHistory();

  const [moxochatopen, setMoxochatopen] = useState(false);
  const { setLoaderConfig } = useContext(LoaderContext);
  const [profileDetails, setProfileDetails] = useState({});
  const [bindersIdArray, setBindersIdArray] = useState([]);

  const [filterMoxoData, setFilterMoxoData] = useState();
  const { realTimeLog, setIschatopen, setMsgcount } = useContext(datacontext);
  const currentPage = window.location.pathname;

  const { setIsBinderChatOpen } = useContext(PropertyContext);

  useEffect(() => {
    if (!binders) {
      setBinderLoader(true);
      if (!currentPage.includes('/share')) {
        const fetchData = async () => {
          getMoxoBinder().then((resp) => {
            if (resp?.code == 'YRY_OK') {
              let count = resp?.data?.binders.filter(
                (binder) => binder.binder?.unread_feeds > 0
              ).length;
              setMsgcount(count);
              let data = resp?.data?.binders;
              data.sort(function (a, b) {
                return b?.binder?.created_time - a?.binder?.created_time;
              });
              setBinderLoader(false);
              setMoxoData(data);
              setFilterMoxoData(data);
            } else {
              setBinderLoader(false);
            }
          });
        };
        fetchData();
        const intervalId = setInterval(fetchData, 20000);
        return () => clearInterval(intervalId);
      }
    }
  }, [activityupdate]);

  const getListInfo = async () => {
    setBinderLoader(true);
    const inputData = {
      propertyId: market ? params?.propertyId : params?.dashboardId,
    };
    setLoaderConfig({ isVisible: false });
    let url = '';
    const primaryUserTypeValue = JSON.parse(
      localStorage.getItem('primaryUser')
    );

    if (primaryUserTypeValue == 'Vendor') {
      url = GET_PROPERTY_INDIVIDUAL_VENDOR;
    } else if (primaryUserTypeValue == 'Buyer') {
      url = GET_PROPERTY_INDIVIDUAL_BUYER;
    } else {
      url = GET_PROPERTY_INDIVIDUAL;
    }
    getApiCall(
      url +
        `/${
          ContactUserCard || InitiateSign
            ? proid
            : market
            ? params?.propertyId
            : params?.dashboardId
        }`
    ).then(async (res) => {
      setLoaderConfig({ isVisible: false });
      if (res?.data?.status == '-1') {
        toast.error(res?.data?.message, {
          position: 'top-right',
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          progress: 0,
          theme: 'light',
          style: {
            fontFamily: 'Poppins', // 👈 Inline Poppins font
          },
        });
      } else {
        await setProfileDetails(res?.data);
        const binderId = res?.data?.PropertyDetails?.property?.bindersId;
        await getIndividualBinder(
          res?.data?.PropertyDetails?.property?.propertyUniqueId
        );
      }
    });
  };
  useEffect(() => {
    if (!currentPage.includes('/share')) {
      if (binders) {
        setLoaderConfig({ isVisible: false });
        getListInfo();
      }
    }
  }, [params?.dashboardId, binders, activityupdate, realTimeLog]);

  const buyersId = profileDetails?.PropertyDetails;

  const getIndividualBinder = async (id) => {
    let url;
    if (UserCard) {
      url =
        `${RCP_API_URL}` +
        `v1/me/binder?unique_ids=${userEmail}&tags_include=${id}`;
    } else if (ContactUserCard) {
      url = `${RCP_API_URL}` + `v1/me/binder?unique_ids=${userEmail}`;
    } else {
      url = `${RCP_API_URL}` + `v1/me/binder?tags_include=${id}`;
    }
    try {
      const resp = await getbinderswithtags(url);
      let data = resp?.data?.binders;
      data.sort(function (a, b) {
        return b?.binder?.created_time - a?.binder?.created_time;
      });
      setBinderData(data);
      setBinderLoader(false);
      return resp?.data;
    } catch (error) {
      console.log(error, 'error while fetching binder details');
      history.push('/logout');
    }
  };
  const theme = useTheme();
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <>
      {InitiateSign ? (
        binderLoader ? (
          <Loadingfunc />
        ) : (
          <Grid sx={{ height: '100%' }}>
            {binderData.length ? ( // Check if binderData exists
              binderData
                .sort(
                  (a, b) =>
                    b?.binder?.feeds_timestamp - a?.binder?.feeds_timestamp
                )
                .map((BinderItem) => {
                  return (
                    <Card
                      sx={messageCardCont}
                      style={{
                        display: 'block',
                        cursor: 'pointer',
                      }}
                    >
                      {/* <GroupTopicDetails onShowChat={onShowChat} item={item} /> */}
                      <Typography
                        onClick={() => {
                          // setIschatopen(BinderItem.binder?.id);
                          // setMoxochatopen(true);
                          // setIsBinderChatOpen(true);
                          setOpenbinder(BinderItem.binder?.id);
                        }}
                        sx={displayFlexColumn}
                        style={{ justifyContent: 'space-between' }}
                      >
                        <Typography
                          style={{
                            justifyContent: 'space-between',
                            display: 'flex',
                            marginBottom: '5px',
                          }}
                        >
                          <Tooltip
                            title={BinderItem.binder?.name}
                            placement="bottom"
                            disableInteractive
                            componentsProps={{
                              tooltip: {
                                sx: {
                                  bgcolor: '#fafafa',
                                  boxShadow: '0px 2px 20px lightgray',
                                  color: 'black',
                                  padding: '10px',
                                  fontFamily: 'poppins !important',
                                  fontSize: '14px',
                                },
                              },
                            }}
                          >
                            <Typography
                              sx={{
                                ...poppins500,
                                ...fontsize14,
                                width: '70%',
                                overflow: 'hidden',
                                WebkitBoxOrient: 'vertical',
                                WebkitLineClamp: 2,
                                lineHeight: '1.2',
                                maxHeight: '2.4em',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'pre-line',
                              }}
                            >
                              {BinderItem.binder?.name}{' '}
                              {/* Display binder's name */}
                            </Typography>
                          </Tooltip>

                          {/* Red dot indicator */}
                          {BinderItem.binder?.unread_feeds > 0 && (
                            <Box
                              sx={{
                                height: '10px',
                                width: '10px',
                                backgroundColor: '#d32f2f',
                                borderRadius: '50%',
                                position: 'relative',
                                top: '1px',
                                marginTop: '5px',
                                flexShrink: 0,
                              }}
                            />
                          )}
                        </Typography>
                        <Typography
                          sx={{ ...poppins400, ...fontsize10, ...lastseen }}
                        >
                          Last Activity:{' '}
                          {dayjs(BinderItem?.binder?.feeds_timestamp).format(
                            'On MMM D, YYYY h:mm A'
                          )}{' '}
                          {/* Display some date related to the binder */}
                        </Typography>
                        <Typography
                          style={{
                            justifyContent: 'space-between',
                            display: 'flex',
                          }}
                        >
                          <Typography
                            sx={displayFlex}
                            style={{
                              alignItems: 'center',
                              paddingTop: '10px',
                            }}
                          >
                            <Typography>
                              <CommunicationAvataGroup
                                icon={BinderItem.binder?.users}
                              />
                            </Typography>
                            <Typography sx={{ ...poppins400, ...fontsize10 }}>
                              &nbsp;{BinderItem?.binder?.users?.length}
                            </Typography>
                          </Typography>
                          <Typography
                            style={{ display: 'flex', alignItems: 'end' }}
                          >
                            <ForwardArrow />
                          </Typography>
                        </Typography>
                      </Typography>
                    </Card>
                  );
                })
            ) : (
              <Typography
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  color: '#26344E',
                  alignItems: 'center',
                  justifyContent: 'center',
                  height: '200px',
                }}
              >
                <Typography
                  sx={{ ...poppins500, fontSize: '14px', color: '#000000' }}
                  style={{ marginBottom: '10px' }}
                >
                  Messaging
                </Typography>
                <Typography
                  sx={{
                    fontWeight: 400,
                    fontFamily: 'poppins',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '25px',
                    color: '#666666',
                  }}
                >
                  No binders available currently
                </Typography>
              </Typography>
            )}
          </Grid>
        )
      ) : !binders ? (
        <Card
          variant="outlined"
          sx={{ ...messagingCont, borderRadius: matchessm ? '10px' : '5px' }}
        >
          {/* <MoxoModal /> */}
          <Typography
            style={{
              display: 'flex',
              flexDirection: 'column',
              color: '#26344E',
            }}
          >
            <LabelHeader labelValue="Messaging" />
          </Typography>
          {/* <Card sx={messageCardCont} style={{ marginBottom: "10px" }}>
            <MessageDetails />
          </Card> */}
          <Box
            style={{
              flexDirection: 'column',
              paddingBottom: '40px',
              overflowY: 'scroll',
              height: '100%',
            }}
          >
            {binderLoader ? (
              <Loadingfunc />
            ) : (
              moxoData.length > 0 && // Check if moxoData has any items
              moxoData
                .sort(
                  (a, b) =>
                    b?.binder?.feeds_timestamp - a?.binder?.feeds_timestamp
                )
                .map(
                  (
                    item // Map through moxoData array to render binder details
                  ) => (
                    <Card
                      key={item?.binder?.id} // Use a unique key for each rendered Card
                      sx={messageCardCont}
                      style={{
                        display: 'block',
                        cursor: 'pointer',
                      }}
                    >
                      {/* <GroupTopicDetails onShowChat={onShowChat} item={item} /> */}
                      <Typography
                        onClick={() => {
                          setIschatopen(item?.binder?.id);
                          setMoxochatopen(true);
                        }}
                        sx={displayFlexColumn}
                        style={{ justifyContent: 'space-between' }}
                      >
                        <Typography
                          style={{
                            justifyContent: 'space-between',
                            display: 'flex',
                            marginBottom: '5px',
                            alignItems: 'start',
                          }}
                        >
                          <Tooltip
                            title={item?.binder?.name}
                            placement="bottom"
                            disableInteractive
                            componentsProps={{
                              tooltip: {
                                sx: {
                                  bgcolor: '#fafafa',
                                  boxShadow: '0px 2px 20px lightgray',
                                  color: 'black',
                                  padding: '10px',
                                  fontFamily: 'poppins !important',
                                  fontSize: '14px',
                                },
                              },
                            }}
                          >
                            <Typography
                              sx={{
                                ...poppins500,
                                ...fontsize14,
                                width: '70%',
                                overflow: 'hidden',
                                WebkitBoxOrient: 'vertical',
                                WebkitLineClamp: 2,
                                lineHeight: '1.2',
                                maxHeight: '2.4em',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'pre-line',
                              }}
                            >
                              {item?.binder?.name}
                            </Typography>
                          </Tooltip>

                          {item?.binder?.unread_feeds > 0 && (
                            <Box
                              sx={{
                                height: '10px',
                                width: '10px',
                                backgroundColor: '#d32f2f',
                                borderRadius: '50%',
                                position: 'relative',
                                top: '1px',
                                marginTop: '5px',
                                flexShrink: 0,
                              }}
                            />
                          )}
                        </Typography>
                        <Typography
                          sx={{ ...poppins400, ...fontsize10, ...lastseen }}
                        >
                          Last Activity:{' '}
                          {dayjs(item?.binder?.feeds_timestamp).format(
                            'On MMM D, YYYY h:mm A'
                          )}{' '}
                          {/* Display some date related to the binder */}
                        </Typography>
                        <Typography
                          style={{
                            justifyContent: 'space-between',
                            display: 'flex',
                          }}
                        >
                          <Typography
                            sx={displayFlex}
                            style={{
                              alignItems: 'center',
                              paddingTop: '10px',
                            }}
                          >
                            <Typography>
                              <CommunicationAvataGroup
                                icon={item?.binder?.users}
                              />
                            </Typography>
                            <Typography sx={{ ...poppins400, ...fontsize10 }}>
                              &nbsp;{item?.binder?.users?.length}
                            </Typography>
                          </Typography>
                          <Typography
                            style={{ display: 'flex', alignItems: 'end' }}
                          >
                            <ForwardArrow />
                          </Typography>
                        </Typography>
                      </Typography>
                    </Card>
                  )
                )
            )}
            {!binderLoader && moxoData?.length == 0 && (
              <Typography
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  color: '#26344E',
                  alignItems: 'center',
                  justifyContent: 'center',
                  height: '200px',
                }}
              >
                <Typography
                  sx={{ ...poppins500, fontSize: '14px', color: '#000000' }}
                  style={{ marginBottom: '10px' }}
                >
                  Messaging
                </Typography>
                <Typography
                  sx={{
                    fontWeight: 400,
                    fontFamily: 'poppins',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '25px',
                    color: '#666666',
                  }}
                >
                  No binders available currently
                </Typography>
              </Typography>
            )}
          </Box>
        </Card>
      ) : (
        <Card
          variant="outlined"
          sx={{ ...messagingCont, borderRadius: matchessm ? '10px' : '5px' }}
        >
          {/* <MoxoModal /> */}
          <Typography
            style={{
              display: 'flex',
              flexDirection: 'column',
              color: '#26344E',
            }}
          >
            <LabelHeader labelValue="Messaging" />
          </Typography>
          {/* <Card sx={messageCardCont} style={{ marginBottom: "10px" }}>
            <MessageDetails />
          </Card> */}
          <Box
            style={{
              flexDirection: 'column',
              paddingBottom: '40px',
              overflowY: 'scroll',
              height: '100%',
            }}
          >
            {binderLoader ? (
              <Loadingfunc />
            ) : binderData.length ? ( // Check if binderData exists
              binderData
                .sort(
                  (a, b) =>
                    b?.binder?.feeds_timestamp - a?.binder?.feeds_timestamp
                )
                .map((BinderItem) => {
                  return (
                    <Card
                      sx={messageCardCont}
                      style={{
                        display: 'block',
                        cursor: 'pointer',
                      }}
                    >
                      {/* <GroupTopicDetails onShowChat={onShowChat} item={item} /> */}
                      <Typography
                        onClick={() => {
                          setIschatopen(BinderItem.binder?.id);
                          setMoxochatopen(true);
                          setIsBinderChatOpen(true);
                        }}
                        sx={displayFlexColumn}
                        style={{ justifyContent: 'space-between' }}
                      >
                        <Typography
                          style={{
                            justifyContent: 'space-between',
                            display: 'flex',
                            marginBottom: '5px',
                          }}
                        >
                          <Tooltip
                            title={BinderItem.binder?.name}
                            placement="bottom"
                            disableInteractive
                            componentsProps={{
                              tooltip: {
                                sx: {
                                  bgcolor: '#fafafa',
                                  boxShadow: '0px 2px 20px lightgray',
                                  color: 'black',
                                  padding: '10px',
                                  fontFamily: 'poppins !important',
                                  fontSize: '14px',
                                },
                              },
                            }}
                          >
                            <Typography
                              sx={{
                                ...poppins500,
                                ...fontsize14,
                                width: '70%',
                                overflow: 'hidden',
                                WebkitBoxOrient: 'vertical',
                                WebkitLineClamp: 2,
                                lineHeight: '1.2',
                                maxHeight: '2.4em',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'pre-line',
                              }}
                            >
                              {BinderItem.binder?.name}{' '}
                              {/* Display binder's name */}
                            </Typography>
                          </Tooltip>
                          {/* Red dot indicator */}
                          {BinderItem.binder?.unread_feeds > 0 && (
                            <Box
                              sx={{
                                height: '10px',
                                width: '10px',
                                backgroundColor: '#d32f2f',
                                borderRadius: '50%',
                                position: 'relative',
                                top: '1px',
                                marginTop: '5px',
                                flexShrink: 0,
                              }}
                            />
                          )}
                        </Typography>
                        <Typography
                          sx={{ ...poppins400, ...fontsize10, ...lastseen }}
                        >
                          Last Activity:{' '}
                          {dayjs(BinderItem?.binder?.feeds_timestamp).format(
                            'On MMM D, YYYY h:mm A'
                          )}{' '}
                          {/* Display some date related to the binder */}
                        </Typography>
                        <Typography
                          style={{
                            justifyContent: 'space-between',
                            display: 'flex',
                          }}
                        >
                          <Typography
                            sx={displayFlex}
                            style={{
                              alignItems: 'center',
                              paddingTop: '10px',
                            }}
                          >
                            <Typography>
                              <CommunicationAvataGroup
                                icon={BinderItem.binder?.users}
                              />
                            </Typography>
                            <Typography sx={{ ...poppins400, ...fontsize10 }}>
                              &nbsp;{BinderItem?.binder?.users?.length}
                            </Typography>
                          </Typography>
                          <Typography
                            style={{ display: 'flex', alignItems: 'end' }}
                          >
                            <ForwardArrow />
                          </Typography>
                        </Typography>
                      </Typography>
                    </Card>
                  );
                })
            ) : (
              <Typography
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  color: '#26344E',
                  alignItems: 'center',
                  justifyContent: 'center',
                  height: '200px',
                }}
              >
                <Typography
                  sx={{ ...poppins500, fontSize: '14px', color: '#000000' }}
                  style={{ marginBottom: '10px' }}
                >
                  Messaging
                </Typography>
                <Typography
                  sx={{
                    fontWeight: 400,
                    fontFamily: 'poppins',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '25px',
                    color: '#666666',
                  }}
                >
                  No binders available currently
                </Typography>
              </Typography>
            )}
          </Box>
        </Card>
      )}

      {moxochatopen && (
        <Moxochat open={moxochatopen} onClose={setMoxochatopen} />
      )}
    </>
  );
}

MessagingContainer.propTypes = {};

export default MessagingContainer;
